import { UserImportStore } from './user-import-store';
import { MatchRowsStore } from './match-rows-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new UserImportStore());

  storeBuilder.addRepository(new MatchRowsStore());
}
